import React from 'react'
import Layout from '../components/layout'
import { Helmet } from 'react-helmet'

class Privacy extends React.Component {
  render() {
    return (
      <Layout>
        <Helmet title="Privacy Policy" defer={false} />
        <section className="dib relative w-100 brand-navy lh-copy bg-brand-near-white">
          <div className="center mw8 ph3 ph5-ns pv6 relative">
            <div className="dib relative w-100">
              <div className="db center relative w-100 br3 bg-white shadow-light pa4">
                <h1 className="dib relative w-100 f2 b">PRIVACY POLICY</h1>
                <div>
                  <h2 className="dib relative w-100 f5 b">
                    Effective Date: July 1, 2019
                  </h2>
                  <p>
                    Paytm Labs Inc., hereinafter referred to as “
                    <strong>Paytm</strong>
                    ”, “<strong>we</strong>
                    ”, “<strong>us</strong>” or “<strong>our</strong>
                    ”. At Paytm, we value your trust and respect your privacy.
                    This Privacy Policy explains how we collect, use and
                    disclose personal information when you visit our websites,
                    mobile sites or mobile applications (collectively, “
                    <strong>Platforms</strong>
                    ”), or use any of the products and services offered through
                    the Platforms{' '}
                    <span className="orange">
                      or otherwise offered by us
                    </span>{' '}
                    (collectively, “<strong>Services</strong>
                    ”). You are advised to read this Privacy Policy carefully.
                    By visiting Paytm’s Platforms or using our Services, you
                    consent to our collection, use and disclosure of your
                    personal information in accordance with this Privacy Policy.
                    If you do not agree to the terms of the policy, please do
                    not use or access our Platforms or Services. Note: Our
                    privacy policy may change at any time without prior
                    notification. To make sure that you are aware of any
                    changes, kindly review the policy periodically. This Privacy
                    Policy is effective as of the date above.
                  </p>
                  <h2 className="dib relative w-100 f3 b">
                    Personal Information We Collect
                  </h2>
                  <p>
                    Personal information means information about an identifiable
                    individual. <br />
                    <br /> In order to receive certain Services from us, you
                    will first need to create an account. To create an account,
                    you will need to provide your mobile number, email address
                    and create a password.
                    <br />
                    <br /> When you request a Service from us, we collect
                    personal information as necessary to provide the requested
                    Service. Depending on the Service that is requested, this
                    information may include your name, billing address, mailing
                    address, telephone number, mobile phone number, email
                    address, gender, photo, date of birth, occupation/principal
                    business, payment card information (including cardholder
                    name, number and expiration date), banking information, and
                    information about a payment recipient (such as name, contact
                    information and account information).
                    <br />
                    <br /> When we provide payment processing services to
                    businesses, we collect information about the business as
                    well as information about its owners, officers and
                    guarantors such as name and personal contact information,
                    date of birth, tax identification number and ownership
                    information. We may also collect credit, financial and other
                    personal information about the business, and its officers,
                    owners and guarantors from consumer reporting agencies and
                    relevant financial institutions.
                    <br />
                    <br /> We also collect information relating to the
                    transactions we process on behalf of the business including
                    payment card information and transaction details.
                    <br />
                    <br /> When you browse through our Platforms, we may collect
                    information regarding the device, device location, domain
                    and host from which you access the Platform, the Internet
                    Protocol address of the computer or Internet service
                    provider you are using, and anonymous site statistical data.
                    We may also collect information using cookies (see Cookies
                    section below).
                  </p>
                  <h2 className="dib relative w-100 f3 b">
                    Use Of Personal Information
                  </h2>
                  <p>
                    We use personal information to:
                    <ul className="list-iems-doc">
                      <li>
                        Administer, improve and personalize your experience on
                        the Platforms
                      </li>
                      <li>Provide the Services you have requested</li>
                      <li>
                        Process payments on behalf of our business customers
                      </li>
                      <li>
                        Measure consumer interest in our Platforms and Services
                      </li>
                      <li>
                        Provide you with personalized offers and updates
                        relating to products and services that may be of
                        interest to you based on your previous interactions with
                        our Platforms and use of our Services.
                      </li>
                      <li>
                        Occasionally send you surveys. These surveys ask you for
                        contact information and demographic information (like
                        postal code, age, gender, etc.). We use this data to
                        customize your experience at Paytm, provide you with
                        content that we think you might be interested in and to
                        display content according to your preferences.
                      </li>
                      <li>
                        Resolve disputes, troubleshoot concerns and help promote
                        safe Services
                      </li>
                      <li>
                        Verify your identity in compliance with requirements
                        under anti-money laundering legislation (which may
                        include checking identity against verification sources
                        such as credit bureaus or records maintained by utility
                        or telecommunications companies, and watch lists
                        established by regulatory agencies and similar bodies in
                        Canada and foreign countries)
                      </li>
                      <li>
                        Verifying eligibility for our Services, which may
                        include obtaining credit, financial and personal
                        information from consumer reporting agencies and
                        relevant financial institutions from time to time
                      </li>
                      <li>
                        Detect, prevent and protect you and us against error,
                        fraud and other criminal activity
                      </li>
                      <li>
                        Meet legal, regulatory and self-regulatory requirements
                      </li>
                      <li>
                        To enforce our terms and conditions and collect amounts
                        owed to us
                      </li>
                    </ul>
                    <div>
                      We may use personal information for other purposes with
                      your consent or as permitted or required by law.
                    </div>
                  </p>
                  <h2 className="dib relative w-100 f3 b">
                    Disclosure Of Personal Information
                  </h2>
                  <p>
                    We may disclose personal information to third parties as
                    necessary to provide a Service you have requested (for
                    example, to a payment recipient as necessary to process a
                    payment that you have directed us to make on your behalf).
                    <br />
                    <br />
                    Paytm may transfer personal information to service providers
                    (including affiliates acting in this capacity) that perform
                    services on our behalf, for example, call center, marketing,
                    analytics, fraud and suspicious transaction monitoring,
                    security, information technology and data hosting and
                    processing. Some of these service providers may be located
                    outside of Canada, including in the United States and India,
                    and your personal information may be collected, used,
                    disclosed, stored and processed outside of Canada for the
                    purposes described in this Privacy Policy. Personal
                    information will be subject to Canadian and foreign legal
                    requirements applicable to us, our affiliates and service
                    providers, which may include lawful requirements to disclose
                    personal information to government and national security
                    agencies in certain circumstances. <br />
                    <br />
                    Paytm may use and disclose personal information to parties
                    connected with the proposed or actual financing,
                    securitization, insuring, sale, assignment or other disposal
                    of all or part of Paytm or our business or assets, for the
                    purposes of evaluating and/or performing the proposed
                    transaction. Our assignees or successors may use and
                    disclose your personal information for similar purposes as
                    those described in this Privacy Policy. <br />
                    <br />
                    We may disclose personal information as necessary to resolve
                    disputes, detect, prevent and protect you and us against
                    error, fraud and other criminal activity, enforce our terms
                    and conditions, collect amounts owed to us, meet legal,
                    regulatory, self-regulatory, insurance, audit, and security
                    requirements, and in other circumstances with your consent
                    or as permitted or required by law. <br />
                    <br />
                    Periodically, we may reveal general statistical information
                    about Paytm and its users, such as the number of visitors,
                    number and type of goods and services purchased, and similar
                    information.
                  </p>
                  <h2 className="dib relative w-100 f3 b">Cookies</h2>
                  <p>
                    A “cookie” is a small piece of information stored by a web
                    server on a web browser so it can be later read back from
                    that browser. Cookies may be used to track your visit to our
                    Platforms and other third party sites in order to serve you
                    with advertisements that are more relevant to you and your
                    inferred interests. Cookies are also used to remember you
                    and your preferences when you visit our site, to track the
                    pages of our site that you visit, limit the number of times
                    you see an advertisement, as well as help to measure the
                    effectiveness of an advertising campaign. Cookies may be
                    placed by us or advertising networks.
                    <br />
                    <br />
                    No personal information will be collected via cookies;
                    however, if you previously provided personal information,
                    cookies may be tied to such information. Aggregate cookie
                    and tracking information may be shared with third parties.
                    You may adjust your browser settings to refuse cookies or to
                    notify you when a cookie is set. If you refuse cookies, some
                    features of our Platforms may not function properly and you
                    may not be able to use certain of our Services.
                  </p>
                  <h2 className="dib relative w-100 f3 b">
                    Links To Other Sites
                  </h2>
                  <p>
                    Our site links to other websites that may collect personal
                    information about you. Paytm is not responsible for the
                    privacy practices or the content of those linked websites.
                  </p>
                  <h2 className="dib relative w-100 f3 b">Security</h2>
                  <p>
                    Paytm has appropriate security measures in place to protect
                    against the loss, misuse, and alteration of the information
                    under our control. Whenever you change or access your
                    account information, we offer the use of a secure server.
                    Once your information is in our possession we adhere to
                    strict security guidelines, designed to protect the
                    information against unauthorized access. Authorized Paytm
                    employees and agents who require access to your personal
                    information in order to fulfil their job requirements will
                    have access to your personal information.
                  </p>
                  <h2 className="dib relative w-100 f3 b">Consent</h2>
                  <p>
                    We collect, use and disclose personal information with your
                    consent, except as permitted or required by law. By visiting
                    our Platforms, using our Services or providing your
                    information, you consent to the collection, use and
                    disclosure of your personal information as described in this
                    Privacy Policy. We may be required or permitted under
                    statute or regulation to collect, use or disclose personal
                    information without your consent, for example to comply with
                    a court order, to comply with local or federal regulations
                    or a legally permitted inquiry by a government agency, or to
                    collect a debt owed to us.
                    <br />
                    <br />
                    You may withdraw your consent to our collection, use and
                    disclosure of personal information at any time, subject to
                    contractual and legal restrictions and reasonable notice.
                    Note that if you withdraw your consent to certain uses of
                    your personal information, we may no longer be able to
                    provide our Services.
                  </p>
                  <h2 className="dib relative w-100 f3 b">
                    Access, Correction And Contacting Us
                  </h2>
                  <p>
                    Paytm may establish and maintain a file of your personal information for the purposes described above. Your file will be stored on our servers or those of our service providers. If you wish to request access to or correction of your personal information in our custody or control, you may write to the address or email listed below, with attention to the Privacy Officer. Your right to access or correct your personal information is subject to applicable legal restrictions. We may take reasonable steps to verify your identity before granting access or making corrections. If you wish to make inquiries or complaints or have other concerns about our personal information practices, you may write to us at the address below or by emailing us at <a className="blue" href="mailto:merchantsupport@paytm.ca">
                      merchantsupport@paytm.ca
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

export default Privacy
